<template>
  <div class="row">
    <div class="col-xl-4 col-sm-12 col-12">
      <label class="form-label"><span class="f-w-500 f-14">Nagarpalika</span></label>
      <select class="form-control" v-model="filter_nagarPalika_id">
        <option value="999999" disabled>All</option>
        <option
          v-for="item in filter_nagarPalikas"
          :key="item.id"
          :value="item.id"
        >
          {{ item.name }}
        </option>
      </select>
    </div>

    <div class="col-xl-4 col-sm-12 col-12">
      <label class="form-label"><span class="f-w-500 f-14">Ward Name</span></label>
      <select class="form-control" v-model="filter_nagarPalika_ward_name">
        <option value="999999">All</option>
        <option
          v-for="item in wards"
          :key="item.ward_name"
          :value="item.ward_name"
        >
          {{ item.ward_name }}
        </option>
      </select>
    </div>

    <div class="col-xl-4 col-sm-12 col-12">
      <label class="form-label">&nbsp;</label>
      <button class="btn btn-primary w-100" @click="filter">Filter</button>
    </div>
  </div>

  <div ref="mapRef" style="height: 100vh; width: 100%;"></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import axios from "axios";

// references and state
const mapRef = ref(null);
let map;
let clusterer = null;
let kmlLayer = null;

const filter_nagarPalikas = ref([]);
const wards = ref([]);
const filter_nagarPalika_id = ref(0);
const filter_nagarPalika_ward_name = ref("");

let allMarkers = [];
const BATCH_SIZE = 10000;

onMounted(async () => {
  const loader = new Loader({
    apiKey: "AIzaSyD9gtJ2oDY7AcqUPTjmER1Ki0ZYC4mbIe0",
    version: "weekly",
  });

  const google = await loader.load();

  map = new google.maps.Map(mapRef.value, {
    center: { lat: 20.5937, lng: 78.9629 }, // India center
    zoom: 4,
  });

  clusterer = new MarkerClusterer({ markers: [], map });

  // load initial data
  loadInitialData();
});

async function loadInitialData() {
  try {
    const res = await axios.post("/locations?page=1&limit=5000");
    filter_nagarPalikas.value = res.data.filter_nagarPalikas;
    wards.value = res.data.wards;
  } catch (err) {
    console.error("Failed to load initial data:", err);
  }
}

// filter + show markers + show KML
async function filter() {
  allMarkers = [];
  clusterer.clearMarkers();

  // remove existing KML layer if any
  if (kmlLayer) {
    kmlLayer.setMap(null);
    kmlLayer = null;
  }

  // find selected Nagarpalika
  const selectedNP = filter_nagarPalikas.value.find(
    (n) => n.id == filter_nagarPalika_id.value
  );

  // show its KML if available
  if (selectedNP && selectedNP.kmlurl) {
    const kmlUrl = `https://naturesurvey.in/backend/${selectedNP.kmlurl}`;
    kmlLayer = new google.maps.KmlLayer({
      url: kmlUrl,
      map: map,
      preserveViewport: false, // zoom to KML automatically
    });

    // recenter map if Nagarpalika has default coordinates
    if (selectedNP.default_lat && selectedNP.default_lng) {
      map.setCenter({
        lat: parseFloat(selectedNP.default_lat),
        lng: parseFloat(selectedNP.default_lng),
      });
      map.setZoom(13);
    }
  }

  // fetch and display markers in batches
  let page = 1;
  while (true) {
    const res = await axios.post("/locations", {
      page: page,
      limit: BATCH_SIZE,
      nagarpalika_id: filter_nagarPalika_id.value,
      ward_name: filter_nagarPalika_ward_name.value,
    });

    const rows = res.data.data;
    if (!rows || rows.length === 0) break;

    const newMarkers = rows.map((item) => {
      const marker = new google.maps.Marker({
        position: {
          lat: parseFloat(item.lat),
          lng: parseFloat(item.lng),
        },
        title: item.np_name || "",
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `
          <div>
            <strong>Ward Name:</strong> ${item.ward_column || "N/A"}<br>
            <strong>Scientific Name:</strong> ${item.local_name || "N/A"}<br>
            <strong>Common Name:</strong> ${item.comman_name || "N/A"}<br>
            <strong>Lat:</strong> ${item.lat || "N/A"}<br>
            <strong>Long:</strong> ${item.lng || "N/A"}<br>
            <strong>Girth:</strong> ${item.girth || "N/A"}<br>
            <strong>Height:</strong> ${item.height || "N/A"}<br>
            <strong>Canopy:</strong> ${item.diameter || "N/A"}<br>
            <strong>Ownership:</strong> ${item.ownership || "N/A"}<br>
            <strong>Remark:</strong> ${item.remark || "N/A"}
          </div>`,
      });

      marker.addListener("click", () => {
        infoWindow.open({
          anchor: marker,
          map,
          shouldFocus: false,
        });
      });

      return marker;
    });

    allMarkers = allMarkers.concat(newMarkers);
    clusterer.addMarkers(newMarkers);

    if (rows.length < BATCH_SIZE) break;
    page++;
  }
}
</script>

<style scoped>
.row {
  margin-bottom: 1rem;
}
</style>
